export default __webpack_public_path__ + "static/media/sd-btn-loader.280c499b.svg";